export default __webpack_public_path__ + "static/img_product_brc-d6d0f1a94dddab12ded098c5a0b83d55.png";